import { statuses } from "../../api";
export default {
	state: {
		all: []
	},
	actions: {
		fetchStatuses(context) {
			let token = context.getters.getToken.jwt;

			return statuses({ token }).then(r => {
				context.commit("setStatuses", r.data);
			});
		}
	},
	mutations: {
		setStatuses(state, payload) {
			console.log("setStatuses payload", payload);
			state.all = payload;
		}
	}
};
